import microApp from '@micro-zoe/micro-app';
import painfulJoya from './plugins/painful-joya';
// 因为新版microapp的环境变量修改过，为了基座应用的升级不影响到子应用所以需要适配
import adaptorOldVersion from './plugins/adaptor-old-version';

export default function init() {
  microApp.start({
    plugins: {
      global: [painfulJoya, adaptorOldVersion],
    },
  });
}
